
'use strict';

var Geometry = require('../../../utils/Geometry');
var LabelConverter = require('../../../utils/LabelConverter');

var ERROR_COLOR = '#a00';

L.Path.include({
  noHide: function() {
    if(this.label) {
      this
        .off('mouseover', this._showLabel, this)
        .off('mousemove', this._moveLabel, this)
        .off('mouseout remove', this._hideLabel, this);
    }
    return this;
  }
});

function getString (config) {
  if (config.label === 'Height') {
    config.type = 'distance';
  } else {
    config.type = 'volume';
  }

  return '<div><dt>' + config.label +':</dt><dd>' + LabelConverter.getLabel(config.prop, config.type, config.units) + '</dd></div>';
}

var _formatResults = function (data) {

  var config = {
    prop: null,
    label: null,
    type: 'volume',
    units: data.units
  };

  // TODO: investigate data.name, why it doesn't show, if it should and what line 28 is supposed to do. seems to be a bug.
  var string = '<dl>';
  string + string + '<div class="infobox-name">' + data.name + '</div>';

  if (data.height !== null && data.height !== undefined) {
    config.prop = data.height;
    config.label = 'Height';
    string = string + getString(config);
  }

  if (data.fillVolume !== null && data.fillVolume !== undefined) {
    config.prop = data.fillVolume;
    config.label = 'Fill';
    string = string + getString(config);
  }

  if (data.cutVolume !== null && data.cutVolume !== undefined) {
    config.prop = data.cutVolume;
    config.label = 'Cut';
    string = string + getString(config);
  }

  if (data.totalVolume !== null && data.totalVolume !== undefined) {
    config.prop = data.totalVolume;
    config.label = 'Total';
    string = string + getString(config);
  }

  if (!data.height && !data.fillVolume && !data.cutVolume && !data.totalVolume) {
    string = string + '<div>Processing...</div>';
  }

  if (data.error) {
    string = '<span><b>Error: </b>Please try editing the shape and saving again</span>';
  }

  string = string + '</dl>';

  return string;
};

module.exports = {
  setInfoBox : function(showImmediately) {
    if(this.layer.resource !== 'measurement') {
      return;
    }
    var leafletLayer = this.leafletLayer;
    var props = this.layer.data.properties;

    var options = { className : 'sb-measurement-label', noHide : true };
    var wrapLabel = function(data) {
      return '<div class="content-wrapper' +
        (data.error ? ' content-error' : '') + '">' +
        '<span class="sb-measurement-results content" {{style}}>' +
        _formatResults(data, this) +
        '</span></div>';
    }.bind(this);
    var addLabel, removeLabel;
    var contents, color;

    leafletLayer.unbindLabel(); // Clean state before

    contents = wrapLabel(props);
    if(leafletLayer.options && leafletLayer.options.color) {
      color = leafletLayer.options.color;

      if (props.error) {
        color = ERROR_COLOR;
        leafletLayer.options.color = color;
      }

      contents = contents.replace('{{style}}', 'style="border-color:' + color + '"');
    } else {
      contents = contents.replace('{{style}}', '');
    }

    leafletLayer.bindLabel(contents, options).noHide();

    addLabel = function() {
      leafletLayer._showLabel({
        latlng : Geometry.centroidTop(this.layer.type, leafletLayer.toGeoJSON())
      });
    }.bind(this);
    removeLabel = function() {
      if(leafletLayer.label) {
        leafletLayer._hideLabel();
      }
    };
    this.on('add', addLabel);
    this.on('dragend', addLabel);
    this.on('remove', removeLabel);
    this.on('dragstart', removeLabel);
    if(showImmediately) {
      addLabel();
    }

  },

  setInfoBoxEvents : function() {
    var layer = this;
    var leafletLayer = this.leafletLayer;
    leafletLayer.on('info:show', function() {
      if(!leafletLayer.infoBox) {
        layer.setInfoBox(true);
      }
    });
    leafletLayer.on('info:hide', function() {
      if(leafletLayer.infoBox) {
        leafletLayer.unbindLabel();
      }
    });

    leafletLayer.on('volume-measurements:updated', function() {
      layer.setInfoBox(true);
    });

    leafletLayer.on('color:changed', function() {
      layer.setInfoBox(true);
    });

    leafletLayer.on('layer:moved', function() {
      layer.setInfoBox(true);
    });
  }

};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/InfoBoxMixin.js